import Background from './Background';
import HiddenCollapsedMixin from './mixins/HiddenCollapsedMixin';
import ClickableMixin from './mixins/ClickableMixin';
import ContainableMixin from './mixins/ContainableMixin';
import mixin from '../privates/utils/mixin';

/**
 * @class HoverBox
 * @summary A hover box is a container that changes when the mouse hovers over
 *  it. A hover box has two views: regular and hover. You can
 *  <a href="https://support.wix.com/en/article/attaching-elements-to-a-box" target="_blank">attach</a>
 *  elements to a hover box. Some actions performed on a hover box affect the
 *  elements it contains. For example, [hiding](#hide) a hover box also
 *  effectively hides all the elements in the hover box, although the
 *  values of the [hidden](#hidden) properties of the elements contained in the
 *  hover box do not change.
 * @mixes $w.Element
 * @mixes $w.Background
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.ClickableMixin
 * @mixes $w.ContainableMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.HoverBox
 * @definitionId wysiwyg.viewer.components.HoverBox
 */
class HoverBox extends Background {}

mixin(HoverBox.prototype, HiddenCollapsedMixin.prototype);
mixin(HoverBox.prototype, ClickableMixin.prototype);
mixin(HoverBox.prototype, ContainableMixin.prototype);

export default HoverBox;
